import React from 'react';

function Error() {
  return (
    <div>
      <h1>Error!! page not found</h1>
    </div>
  );
}

export default Error;
